export default class CessionsController {
	static $inject = [
		'$scope',
		'$timeout',
		'$state',
		'$stateParams',
		'CessionsService',
		'notification',
		'$location',
		'$anchorScroll',
		'$uibModal',
		'_',
		'ModalService',
		'$translate'
	];

	constructor(
		$scope,
		$timeout,
		$state,
		$stateParams,
		CessionsService,
		notification,
		$location,
		$anchorScroll,
		$uibModal,
		_,
		ModalService,
		$translate
	) {
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.CessionsService = CessionsService;
		this.notification = notification;
		this.$location = $location;
		this.$anchorScroll = $anchorScroll;
		this.$uibModal = $uibModal;
		this._ = _;
		this.ModalService = ModalService;
		this.$translate = $translate;
	}

	async $onInit() {
		this.tabCessionsAutorise = {};
		this.cessions = {};
		this.loading = false;
		this.form = {};

		this.societe01 = {};
		this.societe01.entity = 'cession';
		this.societe01.societeComIdSelected = null;
		this.societe01.siteComIdSelected = null;

		this.societe02 = {};
		this.societe02.entity = 'cession';
		this.societe02.societeComIdSelected = null;
		this.societe02.siteComIdSelected = null;

		this.btnAutorise = false;

		await this.getSocietesCom();
		await this.getSitesCom();

		this.tabCessionsAutorise = await this.CessionsService.getCessionAutorise();
	}

	async getSocietesCom(Nbliste) {
		this.societesComLoaded = await this.CessionsService.getSocietesCom();

		if (this.societe01.length == 1 && Nbliste == 1) {
			this.societe01.societeComIdSelected = this.societesComLoaded[0].id;
		}

		if (this.societe02.length == 1 && Nbliste == 2) {
			this.societe02.societeComIdSelected = this.societesComLoaded[0].id;
		}

		this.enabledLButtonAutorise();
	}

	async getSitesCom(Nbliste) {
		if (Nbliste == 1) this.sitesComLoaded01 = await this.CessionsService.getSitesCom(this.societe01.societeComIdSelected);
		if (Nbliste == 2) this.sitesComLoaded02 = await this.CessionsService.getSitesCom(this.societe02.societeComIdSelected);

		if (this.societe01.length == 1 && Nbliste == 1) {
			this.societe01.siteComIdSelected = this.sitesComLoaded01[0].id;
		}

		if (this.societe02.length == 1 && Nbliste == 2) {
			this.societe02.siteComIdSelected = this.sitesComLoaded02[0].id;
		}

		this.enabledLButtonAutorise();
	}

	async enabledLButtonAutorise() {
		if (this.societe01.siteComIdSelected != null && this.societe02.siteComIdSelected != null) {
			this.btnAutorise = true;
		} else {
			this.btnAutorise = false;
		}
	}

	async valideAutorise() {
		var message = await this.CessionsService.createAutoriseCession(this.societe01.siteComIdSelected, this.societe02.siteComIdSelected);

		console.log(message.data);

		if (message.data.success == false) {
			this.notification.error(message.data.message);
		} else {
			this.notification.success(message.data.message);
		}

		this.tabCessionsAutorise = await this.CessionsService.getCessionAutorise();
	}

	async deleteCessionAutorise(id) {
		if (id) {
			const modalInstance = this.ModalService.confirm({
				modalTitle: this.$translate.instant('CESSIONS.TITLE', {
					code: ''
				}),
				modalMsg: this.$translate.instant('CESSIONS.DELETE.QUESTION'),
				headerClass: 'modal-danger'
			});

			// Capture `this`
			const self = this;
			modalInstance.result.then(async function () {
				var message = await self.CessionsService.deleteAutoriseCession(id);

				self.notification.success(message.data.message);

				self.tabCessionsAutorise = await self.CessionsService.getCessionAutorise();
			});
		}
	}
}
